import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 4px;
  width: fit-content;
`;

export const Circle = styled.div<{ $isFilled: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $isFilled }) =>
    $isFilled ? 'var(--icon-primary)' : 'var(--icon-soft)'};
`;
